import { render, staticRenderFns } from "./Fichajes.vue?vue&type=template&id=382e8628&scoped=true"
import script from "./Fichajes.vue?vue&type=script&lang=js"
export * from "./Fichajes.vue?vue&type=script&lang=js"
import style0 from "./Fichajes.vue?vue&type=style&index=0&id=382e8628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e8628",
  null
  
)

export default component.exports